import React__default from 'react';
import PropTypes from 'prop-types';
import SliderInput from '../SliderInput/Slider.js';
import { OPEN_ENDS, VARIANTS, MAX, MIN, NO_OP, STEP } from '../constants.js';
import SliderHeader from '../SliderHeader/index.js';
import SliderPresets from '../SliderPresets/index.js';
import Root from './SliderContainer.styles.js';

var SliderContainer = function SliderContainer(_ref) {
  var _ref$deleteTitle = _ref.deleteTitle,
    deleteTitle = _ref$deleteTitle === void 0 ? undefined : _ref$deleteTitle,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isPushable = _ref.isPushable,
    isPushable = _ref$isPushable === void 0 ? false : _ref$isPushable,
    _ref$isReversed = _ref.isReversed,
    isReversed = _ref$isReversed === void 0 ? false : _ref$isReversed,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? undefined : _ref$label,
    _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? undefined : _ref$labels,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? MAX : _ref$max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? MIN : _ref$min,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? NO_OP : _ref$onChange,
    _ref$onChangeComplete = _ref.onChangeComplete,
    onChangeComplete = _ref$onChangeComplete === void 0 ? NO_OP : _ref$onChangeComplete,
    _ref$onDelete = _ref.onDelete,
    onDelete = _ref$onDelete === void 0 ? undefined : _ref$onDelete,
    _ref$onToggleChange = _ref.onToggleChange,
    onToggleChange = _ref$onToggleChange === void 0 ? undefined : _ref$onToggleChange,
    _ref$openEnds = _ref.openEnds,
    openEnds = _ref$openEnds === void 0 ? undefined : _ref$openEnds,
    _ref$presets = _ref.presets,
    presets = _ref$presets === void 0 ? [] : _ref$presets,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? STEP : _ref$step,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$toggleLabel = _ref.toggleLabel,
    toggleLabel = _ref$toggleLabel === void 0 ? undefined : _ref$toggleLabel,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? undefined : _ref$unit,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? undefined : _ref$value,
    _ref$valueLabel = _ref.valueLabel,
    valueLabel = _ref$valueLabel === void 0 ? undefined : _ref$valueLabel,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? VARIANTS.LESS_THAN : _ref$variant;
  var headerTestId = testId ? "".concat(testId, "-header") : undefined;
  var sliderTestId = testId ? "".concat(testId, "-input") : undefined;
  var presetsTestId = testId ? "".concat(testId, "-presets") : undefined;
  return React__default.createElement(Root, {
    "data-testid": testId
  }, label && React__default.createElement(SliderHeader, {
    isSliderActive: !isDisabled,
    label: label,
    htmlFor: id,
    onToggleChange: onToggleChange,
    onDelete: onDelete,
    valueLabel: valueLabel,
    deleteTitle: deleteTitle,
    toggleLabel: toggleLabel,
    unit: unit,
    testId: headerTestId
  }), React__default.createElement(SliderInput, {
    id: id,
    isDisabled: isDisabled,
    isPushable: isPushable,
    isReversed: isReversed,
    labels: labels,
    max: max,
    min: min,
    onChange: onChange,
    onChangeComplete: onChangeComplete,
    openEnds: openEnds,
    step: step,
    testId: sliderTestId,
    value: value,
    variant: variant
  }), presets && React__default.createElement(SliderPresets, {
    onClick: function onClick() {
      onChange.apply(void 0, arguments);
      onChangeComplete.apply(void 0, arguments);
    },
    data: presets,
    isDisabled: isDisabled,
    testId: presetsTestId
  }));
};
SliderContainer.propTypes = {
  deleteTitle: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isPushable: PropTypes.bool,
  isReversed: PropTypes.bool,
  label: PropTypes.string,
  labels: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    position: PropTypes.number.isRequired
  })),
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  onChangeComplete: PropTypes.func,
  onDelete: PropTypes.func,
  onToggleChange: PropTypes.func,
  openEnds: PropTypes.oneOf(Object.values(OPEN_ENDS)),
  presets: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
  })),
  step: PropTypes.number,
  testId: PropTypes.string,
  toggleLabel: PropTypes.string,
  unit: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  valueLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  variant: PropTypes.oneOf(Object.values(VARIANTS))
};
var SliderContainer$1 = SliderContainer;

export { SliderContainer$1 as default };
//# sourceMappingURL=SliderContainer.js.map
